import { render, staticRenderFns } from "./MemberSideNav.vue?vue&type=template&id=3f392896&scoped=true"
import script from "./MemberSideNav.vue?vue&type=script&lang=js"
export * from "./MemberSideNav.vue?vue&type=script&lang=js"
import style0 from "./MemberSideNav.vue?vue&type=style&index=0&id=3f392896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f392896",
  null
  
)

export default component.exports